__turbopack_context__.v({
  "actions": "PersistentEditor-module__Kz0PDa__actions",
  "canvas": "PersistentEditor-module__Kz0PDa__canvas",
  "chatPane": "PersistentEditor-module__Kz0PDa__chatPane",
  "editor": "PersistentEditor-module__Kz0PDa__editor",
  "empty": "PersistentEditor-module__Kz0PDa__empty",
  "error": "PersistentEditor-module__Kz0PDa__error",
  "existingImages": "PersistentEditor-module__Kz0PDa__existingImages",
  "fields": "PersistentEditor-module__Kz0PDa__fields",
  "grid": "PersistentEditor-module__Kz0PDa__grid",
  "header": "PersistentEditor-module__Kz0PDa__header",
  "headerActions": "PersistentEditor-module__Kz0PDa__headerActions",
  "headerChatToggle": "PersistentEditor-module__Kz0PDa__headerChatToggle",
  "headerIcon": "PersistentEditor-module__Kz0PDa__headerIcon",
  "headerStatus": "PersistentEditor-module__Kz0PDa__headerStatus",
  "historyButton": "PersistentEditor-module__Kz0PDa__historyButton",
  "identity": "PersistentEditor-module__Kz0PDa__identity",
  "imageChoices": "PersistentEditor-module__Kz0PDa__imageChoices",
  "imageField": "PersistentEditor-module__Kz0PDa__imageField",
  "imagePreview": "PersistentEditor-module__Kz0PDa__imagePreview",
  "inspector": "PersistentEditor-module__Kz0PDa__inspector",
  "inspectorHeading": "PersistentEditor-module__Kz0PDa__inspectorHeading",
  "mobile": "PersistentEditor-module__Kz0PDa__mobile",
  "moreActions": "PersistentEditor-module__Kz0PDa__moreActions",
  "moreMenu": "PersistentEditor-module__Kz0PDa__moreMenu",
  "muted": "PersistentEditor-module__Kz0PDa__muted",
  "notice": "PersistentEditor-module__Kz0PDa__notice",
  "pageMenu": "PersistentEditor-module__Kz0PDa__pageMenu",
  "pagePickerButton": "PersistentEditor-module__Kz0PDa__pagePickerButton",
  "pagePickerRoot": "PersistentEditor-module__Kz0PDa__pagePickerRoot",
  "panelOpen": "PersistentEditor-module__Kz0PDa__panelOpen",
  "preview": "PersistentEditor-module__Kz0PDa__preview",
  "previewLoading": "PersistentEditor-module__Kz0PDa__previewLoading",
  "publishMenu": "PersistentEditor-module__Kz0PDa__publishMenu",
  "publishSplit": "PersistentEditor-module__Kz0PDa__publishSplit",
  "pulse": "PersistentEditor-module__Kz0PDa__pulse",
  "sheetExpanded": "PersistentEditor-module__Kz0PDa__sheetExpanded",
  "sheetHandle": "PersistentEditor-module__Kz0PDa__sheetHandle",
  "sidebar": "PersistentEditor-module__Kz0PDa__sidebar",
  "spinner": "PersistentEditor-module__Kz0PDa__spinner",
  "textEditor": "PersistentEditor-module__Kz0PDa__textEditor",
  "toolbar": "PersistentEditor-module__Kz0PDa__toolbar",
  "toolsCollapsed": "PersistentEditor-module__Kz0PDa__toolsCollapsed",
});
